import { TEMPLATE_NAMES } from '@/cms/constants/template-names'
import { SlugStaticProps } from '@/cms/types'

export function isPDP(pageProps: SlugStaticProps) {
  return pageProps?.page?.template === TEMPLATE_NAMES.PDP
}

export function isDestinationPage(pageProps: SlugStaticProps) {
  return (pageProps?.page?.template === TEMPLATE_NAMES.CountryPage
    || pageProps?.page?.template === TEMPLATE_NAMES.RegionPage
    || pageProps?.page?.template === TEMPLATE_NAMES.CityPage)
}
